// let serverURL = "https://pertime.expertizo.pk" // server URL for production
// let serverURL = "https://pertime-staging.vercel.app" // server URL for dev environment
// let serverURL = "http://localhost:3000" // server URL for dev environment


let serverURL = process.env.SERVER_URL
console.log("Server URL: ", serverURL)



// server URL for staging envionment
if (window.location.hostname === "localhost") {
  serverURL;
}
export default { serverURL };

// Regular expression to find only numbers
const numberRegex = /^(-?\d+\.\d+)$|^(-?\d+)$/gm;

export const monthNames = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

export const monthShortNames = {
  January: "Jan",
  February: "Feb",
  March: "Mar",
  April: "Apr",
  May: "May",
  June: "Jun",
  July: "Jul",
  August: "Aug",
  September: "Sep",
  October: "Oct",
  November: "Nov",
  December: "Dec"
};

export const monthMap = {
  "January": 1, "February": 2, "March": 3, "April": 4, 
  "May": 5, "June": 6, "July": 7, "August": 8, 
  "September": 9, "October": 10, "November": 11, "December": 12
};

export const lateRules = [
  { minLates: 30, leaveDeductionDays: 2, lateDeductionDays: 4, totalLatesCount: 6 },
  { minLates: 25, leaveDeductionDays: 2, lateDeductionDays: 3, totalLatesCount: 5 },
  { minLates: 20, leaveDeductionDays: 2, lateDeductionDays: 2, totalLatesCount: 4 },
  { minLates: 15, leaveDeductionDays: 2, lateDeductionDays: 1, totalLatesCount: 3 },
  { minLates: 10, leaveDeductionDays: 2, lateDeductionDays: 0, totalLatesCount: 2 },
  { minLates: 5,  leaveDeductionDays: 1, lateDeductionDays: 0, totalLatesCount: 1 }
];
export const deductionRules = [
  { minLates: 30, leaveDeduction: { '<1': 0.5, '>=1,<2': 1 }, lateDeduction: { '<1': 6, '>=1,<2': 5 } },
  { minLates: 25, leaveDeduction: { '<1': 0.5, '>=1,<2': 1 }, lateDeduction: { '<1': 5, '>=1,<2': 4 } },
  { minLates: 20, leaveDeduction: { '<1': 0.5, '>=1,<2': 1 }, lateDeduction: { '<1': 4, '>=1,<2': 3 } },
  { minLates: 15, leaveDeduction: { '<1': 0.5, '>=1,<2': 1 }, lateDeduction: { '<1': 3, '>=1,<2': 2 } },
  { minLates: 10, leaveDeduction: { '<1': 0.5, '>=1,<2': 1 }, lateDeduction: { '<1': 2, '>=1,<2': 1 } },
  { minLates: 5, leaveDeduction: { '<1': 0.5, '>=1,<2': 1 }, lateDeduction: { '<1': 1, '>=1,<2': 0 } },
  { minLates: 0, leaveDeduction: { '<1': 0, '>=1,<2': 0 }, lateDeduction: { '<1': 0, '>=1,<2': 0 } }
];

export const newLateThresholds = [
  { min: 30, salaryDeduct: 4, leaveDeduct: 2 },
  { min: 25, salaryDeduct: 3, leaveDeduct: 2 },
  { min: 20, salaryDeduct: 2, leaveDeduct: 2 },
  { min: 15, salaryDeduct: 1, leaveDeduct: 2 },
  { min: 10, salaryDeduct: 0, leaveDeduct: 2 },
  { min: 5,  salaryDeduct: 0, leaveDeduct: 1 },
];

export const leaveEncashmentDecRule = { 1: 1, 2: 1, 3: 2, 4: 2, 5: 3 };
export const leavesCarryForwardDecRule = { 2: 1, 3: 1, 4: 2, 5: 2 };

export const appTrelloLabels = ["High Priority", "General", "Personal"]
export const cardIdentifier = "expertizo.pk"

export const halfDay = 0.5

export { serverURL, numberRegex };

export const STATIC_TEMPLATES = [
        {
          id: 1,
          dbId: null,  
          title: "Probation Status Email",
          description: "Sent when employee is placed on probation",
          subject: "Probation Period - [Employee Name]",
          body: `Dear [Employee Name],

We are pleased to inform you that you have been placed on probation status.

Previous Employment Status: [Old Status]
New Employment Status: Probation
Effective Date: [Current Date]
Updated Time: [Current Time]

During your probation period:
- Your performance will be evaluated regularly
- You will receive guidance and support from your supervisor
- You are expected to meet the performance objectives outlined in your role
- Probation period is typically 90 days

Best regards,
HR Management System`,
          variables: [
            { label: "Employee Name", value: "[Employee Name]" },
            { label: "Current Date", value: "[Current Date]" },
            { label: "Current Time", value: "[Current Time]" },
            { label: "Old Status", value: "[Old Status]" },
            { label: "New Status", value: "[New Status]" }
          ]
        },

        {
          id: 2,
          dbId: null,  
          title: "Permanent Status Confirmation",
          description: "Sent when employee becomes permanent",
          subject: "Employment Status Updated to Permanent - [Employee Name]",
          body: `Dear [Employee Name],

Congratulations! Your employment status has been updated to Permanent.

Previous Employment Status: [Old Status]
New Employment Status: [New Status]
Effective Date: [Current Date]
Updated Time: [Current Time]

You now have [New Leaves] leaves available for this year.

Best regards,
HR Management System`,
          variables: [
            { label: "Employee Name", value: "[Employee Name]" },
            { label: "Current Date", value: "[Current Date]" },
            { label: "Current Time", value: "[Current Time]" },
            { label: "Old Status", value: "[Old Status]" },
            { label: "New Status", value: "[New Status]" },
            { label: "New Leaves", value: "[New Leaves]" }
          ]
        },

        {
          id: 3,
          dbId: null,  
          title: "Resignation Acceptance Email",
          description: "Sent when an employee resignation is accepted",
          subject: "Resignation Acceptance - [Employee Name]",
          body: `Dear [Employee Name],

This letter confirms that your resignation has been accepted.

Employee Name: [Employee Name]
Previous Employment Status: [Old Status]
New Status: [New Status]
Resignation Approval Date: [Approval Date]
Notice Period: [Notice Period Days] days (based on [Old Status] status)
Last Working Date: [Last Working Date]

During your notice period, please ensure:
- Complete all pending assignments and handover documentation
- Return all company property (ID card, laptop, access cards, etc.)
- Complete exit formalities with HR
- Provide updated contact information for future correspondence

Your final settlement, including pending salary and benefits, will be processed after your last working day.

We appreciate your contributions during your tenure and wish you success in your future endeavors.

Best regards,
HR Management System`,
          variables: [
            { label: "Employee Name", value: "[Employee Name]" },
            { label: "Current Date", value: "[Current Date]" },
            { label: "Current Time", value: "[Current Time]" },
            { label: "Old Status", value: "[Old Status]" },
            { label: "New Status", value: "[New Status]" },
            { label: "Approval Date", value: "[Approval Date]" },
            { label: "Last Working Date", value: "[Last Working Date]" },
            { label: "Notice Period Days", value: "[Notice Period Days]" },
          ]
        },

        {
          id: 4,
          dbId: null,  
          title: "Termination Notice Email",
          description: "Sent when an employee is terminated",
          subject: "Employment Termination Notice - [Employee Name]",
          body: `Dear [Employee Name],

We regret to inform you that your employment with our organization has been terminated effective [Current Date].

Employee Name: [Employee Name]
Previous Employment Status: [Old Status]
New Status: [New Status]
Termination Date: [Current Date]
Last Working Date: [Current Date]

This decision has been made after careful consideration and in accordance with company policies.

Please take note of the following:
- Your access to company systems and facilities will be deactivated effective immediately
- Please return all company property (ID card, laptop, access cards, documents, etc.) by end of business today
- Contact HR to complete exit formalities and final settlement procedures
- Your final settlement, including pending salary and applicable benefits, will be processed as per company policy

An HR representative will contact you regarding the exit process and final settlement details.
We wish you the best in your future endeavors.

Best regards,
HR Management System`,
          variables: [
            { label: "Employee Name", value: "[Employee Name]" },
            { label: "Current Date", value: "[Current Date]" },
            { label: "Current Time", value: "[Current Time]" },
            { label: "Old Status", value: "[Old Status]" },
            { label: "New Status", value: "[New Status]" }
          ]
        },

        {
          id: 5,
          dbId: null,  
          title: "New Note Notification Email",
          description: "Sent when an regular note is added to employee record",
          subject: "New Note Added to Your Employee Record - [Employee Name]",
          body: `Dear [Employee Name],

A new note has been added to your employee record.

Employee: [Employee Name]
Added By: [Admin Name]
Date: [Current Date]
Time: [Current Time]
Note Content: [Note Text]

You can view the complete note and your employee details in the HR Management System.
If you have any questions or concerns about this note, please contact HR.

Best regards,
HR Management System`,
          variables: [
            { label: "Employee Name", value: "[Employee Name]" },
            { label: "Current Date", value: "[Current Date]" },
            { label: "Current Time", value: "[Current Time]" },
            { label: "Admin Name", value: "[Admin Name]" },
            { label: "Note Text", value: "[Note Text]" }
          ]
        },

        {
          id: 6,
          dbId: null,  
          title: "Salary Increase Notification Email",
          description: "Sent when a salary increase note is added to employee record",
          subject: "Salary Increment Notification - [Employee Name]",
          body: `Dear [Employee Name],

Congratulations! We are pleased to inform you that your salary has been increased.

Employee: [Employee Name]
Effective Date: [Effective Date]
Updated Time: [Current Time]
Salary Details:
Previous Salary: [Old Salary]
New Salary: [New Salary]
Increment Amount: [Increment Amount]
Increment Percentage: [Increment Percentage]%
Note from Management: [Note Text]

This salary increment reflects your valuable contributions, dedication, and excellent performance. We appreciate your continued commitment to the organization and look forward to your ongoing success.

Your updated salary will be reflected in your payroll starting from the effective date mentioned above.

If you have any questions regarding this increment, please contact HR.

Congratulations once again!

Best regards,
HR Management System`,
          variables: [
            { label: "Employee Name", value: "[Employee Name]" },
            { label: "Effective Date", value: "[Effective Date]" },
            { label: "Current Time", value: "[Current Time]" },
            { label: "Admin Name", value: "[Admin Name]" },
            { label: "Note Text", value: "[Note Text]" },
            { label: "Old Salary", value: "[Old Salary]" },
            { label: "New Salary", value: "[New Salary]" },
            { label: "Increment Amount", value: "[Increment Amount]" },
            { label: "Increment Percentage", value: "[Increment Percentage]" },
            { label: "Effective Date", value: "[Effective Date]" },
          ]
        }
      ]
// Used until an admin sets a Company Policy URL in Settings > General Settings
export const DEFAULT_POLICY_URL = "https://docs.google.com/document/d/18vAouRMNTxXOurNbEmDsGmWDG8romvkriYaVBhmC4qY/preview";



// WEBPACK FOOTER //
// ./src/assets/config/constants.js